import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { BUSINESS_NAME, CALL_URL, CONTACT_ADDRESS, CONTACT_PHONE_DISPLAY } from "../config";

function AboutUs() {
    return (
        <div>
            <Header />
            <main className="section">
                <div className="container">
                    <div className="columns is-centered">
                        <div className="column is-8">
                            <h1 className="title is-3 has-text-centered">About Us</h1>

                            <div className="content is-size-5">
                                <p>
                                    {BUSINESS_NAME} is a dairy business based in Murang'a. We buy milk from dairy
                                    farmers and pay them for it.
                                </p>

                                <h2 className="title is-4">What we do</h2>
                                <p>
                                    We collect milk from farmers along our collection routes. Each delivery is
                                    weighed and recorded against the farmer who brought it, with the date and
                                    whether it was the morning or the evening collection.
                                </p>

                                <h2 className="title is-4">How farmers are paid</h2>
                                <p>
                                    What a farmer is owed is worked out from the milk recorded and the milk price.
                                    A cash advance, or goods taken on credit, is recorded too and deducted when
                                    payment is made, so that every payment can be explained to the farmer.
                                    We pay through M-Pesa, or through the farmer's bank or SACCO account.
                                </p>

                                <h2 className="title is-4">What we aim for</h2>
                                <p>
                                    Accurate records, clear accounts and payments made on time. A farmer who
                                    thinks a record is wrong can tell us and we will check it.
                                </p>

                                <h2 className="title is-4">Contact us</h2>
                                <p>
                                    {BUSINESS_NAME}
                                    <br />
                                    {CONTACT_ADDRESS}
                                    <br />
                                    Call <a href={CALL_URL}>{CONTACT_PHONE_DISPLAY}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default AboutUs;
